const shared = {
  caliberTitle: '측정 기준 버전 및 데이터 기준일',
  caliber: '기준',
  through: '기준일',
  batch: '배치',
  denominator: '분모',
  loading: '측정 데이터를 불러오는 중…',
  readFailure: '데이터를 불러오지 못했습니다',
  readFailureClarification: '기업이 AI 결과에 없다는 뜻이 아닙니다. 데이터 읽기 실패와는 서로 다른 사실입니다.',
  permissionTitle: '이 프로젝트에 접근할 권한이 없습니다',
  permissionBody: '권한이 있는 프로젝트로 전환하거나 프로젝트 관리자에게 접근 권한을 요청하세요.',
  retry: '다시 불러오기',
  closeEvidence: '근거 닫기',
  provenance: {
    real: '실제 데이터',
    construct: '구성 데이터',
    placeholder: '자리표시자',
  },
  session: {
    secureSession: '보안 세션',
    contextTitle: 'Navigator 시작하기.',
    contextBody: '기업 공간으로 안전하게 이동합니다.',
    pathLabel: '계정 설정 진행',
    pathOneTitle: '이메일 확인',
    pathOneBody: '일회용 로그인 링크는 활성 워크스페이스 구성원에게만 전송됩니다.',
    pathTwoTitle: '기업 선택 또는 만들기',
    pathTwoBody: '현재 세션은 해당 기업이 배정한 프로젝트만 읽을 수 있습니다.',
    pathThreeTitle: '작업 시작',
    pathThreeBody: '내부 자격 증명을 노출하지 않고 진단, 실행, 성과를 다시 엽니다.',
    memberEntry: '기업 구성원 로그인',
    requestTitle: '이메일로 계속.',
    requestLead: '기존 구성원은 로그인하고, 신규 사용자는 확인 후 기업 공간을 만듭니다.',
    afterLogin: '로그인 후',
    destination: {
      diagnosis: '진단으로 돌아가기',
      results: '성과로 돌아가기',
      action: '실행으로 돌아가기',
      research: '기업 연구로 돌아가기',
    },
    emailLabel: '업무용 이메일',
    invalidEmail: '올바른 업무용 이메일을 입력하세요.',
    sendLink: '계속',
    sending: '보내는 중…',
    privacyTitle: '기업 구성원 전용.',
    privacyBody: '이메일은 로그인과 필수 계정 알림에만 사용됩니다.',
    checkEyebrow: '요청 접수 완료',
    checkTitle: '받은편지함을 확인하세요',
    checkLead: '보안 링크를 보냈습니다. 이 기기에서 이메일을 열어 계속하세요.',
    linkLifetime: '링크는 15분 동안 유효',
    resendShort: '다시 보내기',
    changeEmail: '다른 이메일 사용',
    verifyingEyebrow: '구성원 확인 중',
    verifyingTitle: '기업 공간을 여는 중',
    verifyingLead: '일회용 링크를 보호된 브라우저 세션으로 교환하고 있습니다.',
    expiredEyebrow: '링크를 사용할 수 없음',
    expiredTitle: '이 로그인 링크는 만료되었거나 이미 사용되었습니다',
    expiredLead: '같은 승인된 업무용 이메일로 새 링크를 요청하세요. 프로젝트 데이터는 변경되지 않았습니다.',
    requestNewLink: '새 링크 요청',
    problemEyebrow: '연결 중단',
    problemTitle: '로그인 링크를 요청할 수 없습니다',
    problemLead: '연결을 확인한 후 다시 시도하세요. 기업 공간 데이터는 변경되지 않았습니다.',
    chooseSpaceEyebrow: '기업 공간',
    chooseSpaceTitle: '이번에 사용할 기업 공간 선택',
    chooseSpaceLead: '{email} 계정은 여러 기업 공간에 접근할 수 있습니다. 선택한 공간의 데이터만 불러오며 나중에 다시 전환할 수 있습니다.',
    openingSpace: '여는 중…',
    chooseSpaceFailed: '이 기업 공간을 열 수 없습니다. 다시 시도하세요.',
    createEyebrow: '이메일 확인 완료',
    createContextTitle: '하나의 신원으로 소속된 모든 기업에.',
    createContextBody: '기업 공간에는 프로젝트, 멤버, 메모리와 권한이 저장됩니다.',
    createTitle: '기업 공간 만들기.',
    createLead: '기본 정보를 입력하세요. 1인 창업자는 브랜드명을 사용할 수 있습니다.',
    verifiedIdentity: '확인 완료',
    orgName: '기업 / 브랜드 / 팀 이름',
    region: '주요 운영 지역',
    website: '웹사이트 또는 프로필',
    optional: '선택',
    terms: '이 기업을 대표할 권한이 있으며 약관과 개인정보 보호정책에 동의합니다.',
    createButton: '기업 공간 만들기',
    creatingWorkspace: '만드는 중…',
    regionCN: '중국 본토',
    regionGlobal: '기타 국가 또는 지역',
    regionHK: '중국 홍콩',
    regionTW: '중국 대만',
    regionJP: '일본',
    regionKR: '대한민국',
    createBoundary: '가입만으로 유료 플랜이 시작되지 않습니다.',
    companyNameInvalid: '기업, 브랜드 또는 팀 이름을 입력하세요.',
    termsRequired: '계속하기 전에 약관에 동의하세요.',
    registrationFailed: '기업 공간을 만들 수 없습니다. 다시 시도하세요.',
    footerSecurity: '일회용 링크 · 보호 Cookie · 테넌트 격리',
    footerHelp: '도움말 · hello@monolithos.ai',
  },
} as const

export default shared
